module.exports = __webpack_public_path__ + "static/media/object-ungroup.0a242cc2.svg";